import React from 'react';

const AttachedPrescription = ({ stepperProgressCartData }) => {
    // Extract the URL to keep the JSX clean
    const prescriptionUrl = stepperProgressCartData?.selectedPrescription?.[0]?.prescriptionImgUrl;

    return (
        <div className="w-full bg-[#FFFFFF] mt-3 p-4 rounded-[16px] shadow-sm">
            <label className="block mb-2 text-sm font-medium text-gray-700">
                Attached prescription
            </label>
            <div className='flex justify-center items-center border border-dashed border-gray-200 rounded-lg p-2'>
                {prescriptionUrl ? (
                    <img 
                        className="w-full rounded-lg object-contain" 
                        src={prescriptionUrl} 
                        alt="User Prescription"
                        onError={(e) => {
                            e.target.src = 'https://placehold.co/400x400?text=Image+Load+Failed';
                        }}
                    />
                ) : (
                    <div className="text-gray-400 text-xs flex flex-col items-center">
                        <p>No prescription selected</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AttachedPrescription;